import React from 'react';

import { FormattedMessage } from '../../../../util/reactIntl';

import css from './Hero.module.css';

/**
 * Opening story of the about page.
 */
const Hero = () => (
  <section className={css.root}>
    <div className={css.inner}>
      <p className={css.eyebrow}>
        <FormattedMessage id="AboutHero.eyebrow" defaultMessage="About PostPartners" />
      </p>
      <h1 className={css.title}>
        <FormattedMessage
          id="AboutHero.title"
          defaultMessage="We built this because<line>we needed it</line>"
          values={{
            line: chunks => <span className={css.titleLine}>{chunks}</span>,
          }}
        />
      </h1>
      <p className={css.text}>
        <FormattedMessage
          id="AboutHero.founded"
          defaultMessage="PostPartners was founded by mothers who experienced firsthand what so many families do in the weeks after birth: the exhaustion, the uncertainty, and the quiet realization that the support you desperately need isn't easy to find."
        />
      </p>
      <p className={css.text}>
        <FormattedMessage
          id="AboutHero.transition"
          defaultMessage="The postpartum period is one of the most significant transitions a family will ever navigate. Yet the care ecosystem surrounding it remains fragmented, unvetted, and largely invisible."
        />
      </p>
    </div>
  </section>
);

export default Hero;
